import React, { useEffect, useState } from 'react';
import ImaModal from './ImaModal';
import CatamaniaModal from './CatamaniaModal';
import Projects from './Projects';
import FlashingDot from '../FlashingDot';
import CV from './CV';
import IArtisanatModal from './IArtisanatModal';
import Phone from './Phone';

const Desk = ({ trackedObjects }) => {

  const [isMacModalOpen, setIsMacModalOpen] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [isCatamaniaModalOpen, setIsCatamaniaModalOpen] = useState(false);
  const [isImaModalOpen, setIsImaModalOpen] = useState(false);
  const [isCVModalOpen, setIsCVModalOpen] = useState(false);
  const [isIArtisanatModalOpen, setIsIArtisanatModalOpen] = useState(false);


  const [bottle, setBottle] = useState(null);
  const [mac, setMac] = useState(null);
  const [headset, setHeadset] = useState(null);
  const [cv, setCv] = useState(null);
  const [phone, setPhone] = useState(null);
  const [outlet, setOutlet] = useState(null);

  useEffect(() => {
    //console.log("Tracked Objects:", trackedObjects);
    setBottle(trackedObjects.find(o => o.name.toLowerCase() === 'bottle'));
    setMac(trackedObjects.find(o => o.name.toLowerCase() === 'mac-bg'));
    setHeadset(trackedObjects.find(o => o.name.toLowerCase() === 'headset'));
    setCv(trackedObjects.find(o => o.name.toLowerCase() === 'cv'));
    setPhone(trackedObjects.find(o => o.name.toLowerCase() === 'phone-display'));
    setOutlet(trackedObjects.find(o => o.name.toLowerCase() === 'socket-grounding-prong'));
  }, [trackedObjects]);


  function showImaModal() {
    setIsImaModalOpen(true);
  };

  function showCatamaniaModal() {
    setIsCatamaniaModalOpen(true);
  };

  function showMacModal() {
    setIsMacModalOpen(true);
  };

  function showPhoneModal() {
    setIsPhoneModalOpen(true);
  };

  function showCVModal() {
    setIsCVModalOpen(true);
  };

  function showIArtisanatModal() {
    setIsIArtisanatModalOpen(true);
  };

  return ( 
    <>
      {bottle && <FlashingDot onClick={showCatamaniaModal} position={{ x: bottle.pos.x, y: bottle.pos.y }}/>}
      {mac && <FlashingDot onClick={showMacModal} position={{ x: mac.pos.x, y: mac.pos.y }}/>}
      {headset && <FlashingDot onClick={showImaModal} position={{ x: headset.pos.x, y: headset.pos.y }}/>}
      {cv && <FlashingDot onClick={showCVModal} position={{ x: cv.pos.x, y: cv.pos.y }}/>}
      {phone && <FlashingDot onClick={showPhoneModal} position={{ x: phone.pos.x, y: phone.pos.y }}/>}
      {outlet && <FlashingDot onClick={showIArtisanatModal} position={{ x: outlet.pos.x, y: outlet.pos.y }}/>}
      <Projects isModalOpen={isMacModalOpen} setIsModalOpen={setIsMacModalOpen} />
      <ImaModal isModalOpen={isImaModalOpen} setIsModalOpen={setIsImaModalOpen} />
      <CV isModalOpen={isCVModalOpen} setIsModalOpen={setIsCVModalOpen} />
      <CatamaniaModal isModalOpen={isCatamaniaModalOpen} setIsModalOpen={setIsCatamaniaModalOpen} />
      <IArtisanatModal isModalOpen={isIArtisanatModalOpen} setIsModalOpen={setIsIArtisanatModalOpen} />
      <Phone isModalOpen={isPhoneModalOpen} setIsModalOpen={setIsPhoneModalOpen} />
    </>
  );
};

export default Desk;